<template>
  <div
    class="welcome"
    :style="{
      backgroundImage: 'url(' + require('@/assets/img/crm_1.svg') + ')',
    }"
  >
    <b-overlay :show="isLoading" variant="white" spinner-variant="primary">
      <div class="col-6">
        <h2 class="mb-4">👋 <br />Вітаємо, {{ user.first_name }}</h2>
        <h3 class="mb-2">у Кадровому Резерві</h3>
        <div class="school mb-4"><span>КШДУ ім. Сергія Нижного</span></div>
        <p>
          Команда КШДУ ім. Сергія Нижного пропонує Вам нову програму
          <strong class="d-block"> Кадровий Резерв</strong>
        </p>
        <p>
          Ви маєте можливість пройти якісну професійну підготовку до співбесіди,
          попереднє тестування та значно підвищити шанси на отримання бажаної
          посади у державному секторі.
        </p>
        <p>
          <strong> Почніть з трьох простих кроків</strong>
        </p>
        <ul class="steps">
          <li>
            <b-icon-check-circle-fill />
            Зареєструватись на платформі
          </li>
          <li :class="{ incomplete: !user.resume_url }">
            <b-icon-check-circle-fill />
            Завантажити резюме
          </li>
          <li :class="{ incomplete: !stepOne }">
            <b-icon-check-circle-fill />
            Пройти тестування
          </li>
        </ul>
        <div class="d-flex align-items-center">
          <b-button
            :to="{ name: 'candidate-tests' }"
            size="lg"
            variant="primary"
            style="margin-right: 20px"
            v-if="!stepOne && user.resume_url"
          >
            Пройти тестування
          </b-button>
          <b-button
            :to="{ name: 'candidate-profile' }"
            size="lg"
            variant="primary"
            style="margin-right: 20px"
            v-if="!user.resume_url"
          >
            Завантажити резюме
          </b-button>
          <b-button
            variant="primary"
            v-if="stepOne && user.resume_url"
            :to="{ name: 'candidate-vacancies' }"
          >
            Актуальні вакансії</b-button
          >
        </div>
      </div>
    </b-overlay>
    <div
      class="bg-right"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/crm_welcome.png') + ')',
      }"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      test_results: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.userData;
    },
    stepOne() {
      let completed = false;
      if (this.test_results.length > 0) {
        completed = true;
      }
      return completed;
    },
  },
  methods: {
    async getTestResults() {
      this.isLoading = true;
      let args = {
        collectionName: "test_results",
        where: ["user_id", "==", this.user.id],
      };
      let result = await this.$db.getCollection(args);
      this.test_results = result.docs;

      this.isLoading = false;
    },
  },
  mounted() {
    this.getTestResults();
  },
};
</script>

<style lang="scss" scoped>
.welcome {
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 6px 10px 0px rgba(#000, 0.1);
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: auto 70%;
  position: relative;
  .steps {
    padding: 0;
    li {
      font-size: 20px;
      list-style: none;
      padding-bottom: 6px;
      &.incomplete {
        color: #ccc;
        svg {
          fill: #ccc;
        }
      }
      svg {
        fill: rgb(74, 202, 74);
        margin-right: 6px;
      }
    }
  }
  .bg-right {
    right: 0px;
    bottom: 0;
    left: 55%;
    top: 0;
    position: absolute;
    background-position: left center;
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  h2 {
    color: var(--primary-color);
  }
  h3 {
    font-weight: bold;
  }
  .school {
    background: var(--secondary-color);
    display: inline-flex;
    padding: 4px 12px;
    font-size: 24px;
    color: var(--primary-color);
  }
}
</style>
